var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "floorplan-dots" },
    [
      _vm._l(_vm.filterFloorplanVisible, function (panorama) {
        return _c(
          "span",
          {
            key: panorama.objectId,
            staticClass: "floorplan-point",
            class: {
              "pilot-active":
                _vm.pilotAnimation.indexMapping[panorama.objectId] &&
                _vm.pilotAnimation.indexMapping[panorama.objectId] <=
                  _vm.pilotAnimation.index,
              active: _vm.hoveredPanorama.objectId === panorama.objectId,
            },
            style: {
              transform: _vm.pointPosition(panorama),
            },
            on: {
              mouseenter: function ($event) {
                return _vm.setHoveredPanorama(panorama)
              },
              mouseleave: function ($event) {
                return _vm.setHoveredPanorama({})
              },
              click: function ($event) {
                return _vm.selectPanorama(panorama)
              },
            },
          },
          [
            _vm.hoveredPanorama.objectId === panorama.objectId
              ? _c(
                  "span",
                  {
                    staticClass: "floorplan-point-tag",
                    style: {
                      transform: `translateX(calc(-50% + 10px)) scale(${
                        1 / _vm.scale / _vm.floorplanScale
                      })`,
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          panorama.customCategory || _vm.$t(panorama.category)
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      _vm._v(" "),
      _vm.isShowDot && _vm.currentPanorama.position
        ? _c("span", {
            staticClass: "floorplan-activated-point",
            style: {
              transform: _vm.pointPosition(_vm.currentPanorama),
              backgroundColor: _vm.activatedColor,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }